import React, { Dispatch, SetStateAction, useState } from "react";
import ErrorMessage from "../../../../core/common/ErrorMessage";
import { ErrorType } from "../../../../types/common-type";
import CommonSelect2 from "../../../../core/common/commonSelect2";
import { countryOptions } from "../../../../core/data/js/common-data";

interface ModifyProps {
  handleClose: () => void;
  handleSubmit: (data: any) => void;
}

const ModifyInviteModal: React.FC<ModifyProps> = ({
  handleClose,
  handleSubmit,
}) => {
  const [formData, setFormData] = useState({
    email: "",
    countryCode: "",
    phone: "",
  });
  const [errors, setErrors] = useState<ErrorType>();

  function handleSubmitModal() {
    handleSubmit(formData);
  }

  return (
    <div>
      <div className="modal-backdrop fade show" onClick={handleClose} />
      <div
        className="modal fade show"
        style={{ display: "block" }}
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div
            className="modal-content mx-auto"
            style={{ width: "97%", maxWidth: 500 }}
          >
            <div className="modal-header d-flex justify-content-end ">
              <button
                type="button"
                className="btn-close custom-btn-close"
                onClick={handleClose}
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <div className="modal-body pb-0 py-0 pt-3 px-md-4 ">
              <div
                className="p-3 mb-3 rounded-2 "
                style={{ backgroundColor: "#FDF3F4" }}
              >
                <h2>
                  <i
                    className="ti ti-edit me-2"
                    style={{ color: "#EA868F" }}
                  ></i>
                  Instructions
                </h2>
                <ul className="list-style-disc text-gray mt-2">
                  <li className="mb-1">
                    <i className="ti ti-point me-1"></i>Use this option to
                    resend an invite to applicants.
                  </li>
                  <li>
                    <i className="ti ti-point me-1"></i>You can modify the phone
                    number and email id.
                  </li>
                </ul>
              </div>
              <h4 className="modal-title">Modify Invite</h4>
              <form onSubmit={handleSubmitModal}>
                <div className="px-sm-2 ">
                  <div className="mb-3 mt-3">
                    <label className="form-label">Email ID</label>
                    <div className="">
                      <input
                        type="email"
                        className="form-control mb-2"
                        name="email"
                        value={formData?.email ?? ""}
                        placeholder="Enter Email"
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            email: e.target.value,
                          }));
                        }}
                      />
                      <ErrorMessage message={errors?.email} />
                    </div>
                  </div>

                  <div className="mb-3 mt-3">
                    <label className="form-label">Mobile Number</label>
                    <div className="input-group">
                      <div style={{ width: "120px" }}>
                        <CommonSelect2
                          className="select "
                          options={countryOptions}
                          showValue={true}
                          defaultValue={formData?.countryCode ?? ""}
                          onChange={(option: any) => {
                            setFormData((prev) => ({
                              ...prev,
                              countryCode: option.value,
                            }));
                          }}
                        />
                      </div>
                      <input
                        type="text"
                        inputMode="numeric"
                        className="ms-1 form-control mb-2"
                        name="phone"
                        value={formData?.phone ?? ""}
                        placeholder="eg: 23894"
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            phone: e.target.value,
                          }));
                        }}
                      />
                      <ErrorMessage message={errors?.phone} />
                    </div>
                  </div>
                </div>
                <div className="modal-footer border-top ">
                  <button
                    type="submit"
                    className="btn btn-secondary px-4 py-1 me-1"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary px-4 py-1 ">
                    Send
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModifyInviteModal;
